
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-12 gap-12 mb-12">
          {/* Sol Bölüm */}
          <div className="col-span-5">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/31228f50-38f5-4c6b-86fc-ab24e41fc90e.png" 
                alt="Logo" 
                className="h-12 w-12 object-contain"
              />
              <h3 className="text-2xl font-bold">MS Security Labs</h3>
            </div>
            <p className="text-gray-600 leading-relaxed mb-6">
              Microsoft Sentinel, Intune ve Microsoft EDR konularında teknik makaleler, açık kaynak projeleri.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-full hover:border-blue-500 hover:text-blue-500 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-full hover:border-blue-500 hover:text-blue-500 transition-colors cursor-pointer"
              >
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-full hover:border-blue-500 hover:text-blue-500 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Orta Bölüm */}
          <div className="col-span-4">
            <div className="space-y-6">
              <div>
                <h4 className="text-xs uppercase text-gray-500 mb-2 font-semibold tracking-wider">İLETİŞİM</h4>
                <p className="text-white text-sm">ozgur@ozgurcebi.com</p>
              </div>
            </div>
          </div>

          {/* Sağ Bölüm - Newsletter */}
          <div className="col-span-3">
            <h4 className="text-xs uppercase text-gray-500 mb-4 font-semibold tracking-wider">BÜLTEN</h4>
            <p className="text-gray-400 text-sm mb-4">Yeni makaleler ve güvenlik güncellemeleri için abone olun.</p>
            <form 
              id="newsletter-form"
              data-readdy-form
              action="https://readdy.ai/api/form/d6ark46a728k8ctu3gq0"
              method="POST"
              className="space-y-3"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const email = formData.get('email');
                
                if (!email) {
                  alert('Lütfen email adresinizi girin');
                  return;
                }
                
                fetch(form.action, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString(),
                })
                  .then(() => {
                    alert('Başarıyla abone oldunuz!');
                    form.reset();
                  })
                  .catch(() => {
                    alert('Bir hata oluştu. Lütfen tekrar deneyin.');
                  });
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Email adresiniz"
                required
                className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-blue-500"
              />
              <button
                type="submit"
                className="w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Abone Ol
              </button>
            </form>
          </div>
        </div>

        {/* Alt Bölüm */}
        <div className="pt-8 border-t border-gray-800 flex items-center justify-between">
          <p className="text-gray-500 text-sm">
            &copy; 2025 ozgurcebi.com Tüm hakları saklıdır.
          </p>
          <div className="flex items-center space-x-6">
            <Link to="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">
              Gizlilik
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">
              Kullanım Koşulları
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
